<h2 mat-dialog-title>Удалить платёж?</h2>
<mat-dialog-content>
  <div class="warn-icon-wrap">
    <mat-icon color="warn" class="warn-icon">warning</mat-icon>
  </div>
  <p class="warn-text">Это действие нельзя отменить.</p>
  <div class="payment-meta">
    <div class="payment-meta-row">
      <span>Сумма:</span>
      <strong>{{ data.payment.amount }}&nbsp;&#8381;</strong>
    </div>
    <div class="payment-meta-row">
      <span>Способ оплаты:</span>
      <strong>{{ data.payment.payment_method_display }}</strong>
    </div>
    <div class="payment-meta-row" *ngIf="data.payment.payment_date">
      <span>Дата:</span>
      <strong>{{ data.payment.payment_date | date:'dd.MM.yyyy HH:mm' }}</strong>
    </div>
    <div class="payment-meta-row" *ngIf="data.payment.description">
      <span>Описание:</span>
      <strong>{{ data.payment.description }}</strong>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Отмена</button>
  <button mat-raised-button color="warn" (click)="dialogRef.close(true)">Удалить</button>
</mat-dialog-actions>
